<template>
  <teleport to="#teleport-modal">
    <div
      v-show="isShow"
      v-body-scroll-lock="isShow"
      class="fixed top-0 left-0 w-full h-full flex items-start justify-center z-50 bg-gray-32"
    >
      <div class="bg-slate-100 mt-9 rounded-lg" style="width: 768px">
        <div class="bg-white rounded-t-lg py-4 px-8 border-b border-gray-12">
          <div class="headline-sm leading-6">成約報告</div>
        </div>
        <div
          class="py-10 px-8 flex flex-col gap-6 overflow-y-scroll"
          style="max-height: calc(100vh - 36px - 57px - 65px - 36px)"
        >
          <div class="p-8 bg-white rounded-lg">
            <div class="title-md">案件の結果</div>
            <div class="mt-2">
              <div class="leading-none">
                <input
                  type="radio"
                  name="status"
                  value="success"
                  id="status_success"
                  class="hidden"
                  v-model="formData.status"
                  @change="validationStatus"
                />
                <label
                  class="inline-flex items-center radio-label cursor-pointer py-1.5 px-0.5"
                  for="status_success"
                >
                  <span class="ml-2 body-md">成約した</span>
                </label>
              </div>
              <div class="mt-2">
                <div class="leading-none">
                  <input
                    type="radio"
                    name="status"
                    value="success_undecided"
                    id="status_success_undecided"
                    class="hidden"
                    v-model="formData.status"
                    @change="validationStatus"
                  />
                  <label
                    class="inline-flex items-center radio-label cursor-pointer py-1.5 px-0.5"
                    for="status_success_undecided"
                  >
                    <span class="ml-2 body-md"
                      >成約した（請求予定額・請求書発行予定日が未定）</span
                    >
                  </label>
                </div>
              </div>
              <div class="mt-2 leading-none">
                <input
                  type="radio"
                  name="status"
                  value="fail"
                  id="status_fail"
                  class="hidden"
                  v-model="formData.status"
                  @change="validationStatus"
                />
                <label
                  class="inline-flex items-center radio-label cursor-pointer py-1.5 px-0.5"
                  for="status_fail"
                >
                  <span class="ml-2 body-md">失注した</span>
                </label>
              </div>
              <div v-if="formError.status" class="body-sm text-error mt-1">
                この項目の選択は必須です
              </div>
            </div>
          </div>
          <div
            v-if="formData.status === 'success'"
            class="p-8 bg-white rounded-lg flex flex-col gap-6"
          >
            <div>
              <div class="title-md">受注内容</div>
              <input
                type="text"
                name="order_detail"
                class="w-full h-10 mt-2 px-4 border border-gray-38 rounded focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-300"
                :class="
                  formError.order_detail
                    ? 'border-error placeholder-error'
                    : 'border-gray-38 placeholder-gray-62'
                "
                placeholder="受注した案件の内容を記入してください"
                v-model.trim="formData.order_detail"
                @input="validationOrderDetail"
              />
              <div
                v-if="formError.order_detail"
                class="body-sm text-error mt-1 pl-4"
              >
                この項目の入力は必須です
              </div>
            </div>
            <div>
              <div class="title-md">請求予定額（税抜）</div>
              <input
                type="text"
                name="scheduled_invoice_report_amount"
                class="w-44 h-10 mt-2 px-4 border border-gray-38 rounded text-right focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-300"
                :class="
                  formError.scheduled_invoice_report_amount
                    ? 'border-error placeholder-error'
                    : 'border-gray-38 placeholder-gray-62'
                "
                placeholder="0"
                maxlength="11"
                v-model="formData.scheduled_invoice_report_amount"
                @input="validationScheduledInvoiceReportAmount"
              />
              <span class="ml-2 body-md">円</span>
              <div
                v-if="formError.scheduled_invoice_report_amount"
                class="body-sm text-error mt-1 pl-4"
              >
                この項目の入力は必須です。半角数字で入力してください
              </div>
            </div>
            <div>
              <div class="title-md">依頼企業への請求書発行予定日</div>
              <input
                type="date"
                max="9999-12-31"
                name="scheduled_invoice_date"
                class="w-44 h-10 mt-2 px-4 border border-gray-38 rounded focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-300"
                :class="
                  formError.scheduled_invoice_date
                    ? 'border-error placeholder-error'
                    : 'border-gray-38 placeholder-gray-62'
                "
                v-model="formData.scheduled_invoice_date"
                @input="validationScheduledInvoiceDate"
              />
              <div
                v-if="formError.scheduled_invoice_date"
                class="body-sm text-error mt-1 pl-4"
              >
                この項目の入力は必須です
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-b-lg py-2 px-8 border-t border-gray-12">
          <div class="flex items-center justify-end gap-2">
            <button
              class="button-lg border rounded-lg bg-white px-8 h-12"
              :class="
                isLoading
                  ? 'text-gray-38 border-gray-12 cursor-auto'
                  : 'text-gray-92 border-gray-38 hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10'
              "
              :disabled="isLoading"
              @click="$emit('cancel')"
            >
              キャンセル
            </button>
            <button
              class="button-lg rounded-lg px-8 h-12"
              :class="
                isLoading
                  ? 'text-gray-38 bg-gray-08 cursor-auto'
                  : 'text-white bg-primary-light-high hover:bg-primary-state-light-high-hover focus:bg-primary-state-light-high-focused active:bg-primary-state-light-high-pressed'
              "
              :disabled="isLoading"
              @click="handleSubmit"
            >
              報告する
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { reactive, toRefs } from 'vue';

export default {
  emits: ['submit', 'cancel'],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      formData: {
        status: '',
        order_detail: '',
        scheduled_invoice_report_amount: '',
        scheduled_invoice_date: '',
      },
      formError: {
        status: false,
        order_detail: false,
        scheduled_invoice_report_amount: false,
        scheduled_invoice_date: false,
      },
    });

    const validationStatus = () => {
      state.formError.status = state.formData.status === '';
      return state.formError.status;
    };

    const validationOrderDetail = () => {
      state.formError.order_detail = state.formData.order_detail === '';
      return state.formError.order_detail;
    };

    const validationScheduledInvoiceReportAmount = () => {
      const pattern = /^([1-9]\d*|0)$/;
      state.formError.scheduled_invoice_report_amount = !pattern.test(
        state.formData.scheduled_invoice_report_amount
      );
      return state.formError.scheduled_invoice_report_amount;
    };

    const validationScheduledInvoiceDate = () => {
      state.formError.scheduled_invoice_date =
        state.formData.scheduled_invoice_date === '';
      return state.formError.scheduled_invoice_date;
    };

    const validationAll = () => {
      validationStatus();
      if (state.formData.status === 'success') {
        validationOrderDetail();
        validationScheduledInvoiceReportAmount();
        validationScheduledInvoiceDate();
      }
      return Object.values(state.formError).includes(true);
    };

    const handleSubmit = () => {
      const hasError = validationAll();
      if (hasError) {
        return;
      }

      emit('submit', state.formData);
    };

    return {
      ...toRefs(state),
      validationStatus,
      validationOrderDetail,
      validationScheduledInvoiceReportAmount,
      validationScheduledInvoiceDate,
      handleSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.radio-label {
  &:before {
    content: '';
    border-radius: 100%;
    @apply bg-white border-gray-62 border-2 w-5 h-5;
  }
  &:hover::before {
    box-shadow: 0 0 0 10px rgba(6, 16, 26, 0.04);
  }
  &:focus::before {
    box-shadow: 0 0 0 10px rgba(6, 16, 26, 0.12);
  }
  &:active::before {
    box-shadow: 0 0 0 10px rgba(6, 16, 26, 0.1);
  }
}

input[type='radio']:checked + .radio-label {
  &:before {
    box-shadow: inset 0 0 0 3px #fff;
    @apply border-primary-light-high bg-primary-light-high;
  }
  &:hover:before {
    box-shadow: inset 0 0 0 3px #fff, 0 0 0 10px rgba(234, 60, 60, 0.04);
  }
  &:focus:before {
    box-shadow: inset 0 0 0 3px #fff, 0 0 0 10px rgba(234, 60, 60, 0.12);
  }
  &:active:before {
    box-shadow: inset 0 0 0 3px #fff, 0 0 0 10px rgba(234, 60, 60, 0.1);
  }
}
</style>
